import { render, staticRenderFns } from "./index-landing-one.vue?vue&type=template&id=989000ec&"
import script from "./index-landing-one.vue?vue&type=script&lang=js&"
export * from "./index-landing-one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports